import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {Row, Col} from 'react-bootstrap';
import TabsNav from '../../../components/tabsNav/Tabs';
import {getLanguage, t} from 'react-switch-lang';
import {format, parseISO} from 'date-fns';
import '../Dashboard.scss';
import NoFormTable from '../../../components/customTable/NoFormTable';
import First from './FirstPotentionaOccuredTable';
import Second from './SecondLigitiationRiskTable';
import {useDepartmentContext} from '../../../contexts/DepartmentContext';
import {useUserContext} from '../../../contexts/UserContext';
import roles from '../../../utils/roles';

const DashboardTable = () => {
  const departments = useDepartmentContext();
  const userAuthorities = useUserContext().authorities;

  const userSuperAdmin = userAuthorities.some((r) =>
    r.includes(roles.role_super_admin)
  );
  const userRiskSector = userAuthorities.some((r) =>
    r.includes(roles.role_risk_sector)
  );

  const [activeTab, setActiveTab] = useState('last-potential-incurred');
  const columns2 = [
    {
      key: 'id',
      dataIndex: 'id',
      title: t('last-risks-by-status-verified.riskId'),
    },
    {
      key: 'title',
      dataIndex: 'title',
      title: t('last-risks-by-status-verified.riskName'),
    },
    {
      key: 'riskTypeName',
      dataIndex: 'riskTypeName',
      title: t('last-risks-by-status-verified.riskTypeName'),
    },
    {
      key: 'riskStatusName',
      dataIndex: getLanguage() === 'mne' ? 'riskStatusName' : 'riskStatusNameEn',
      title: t('last-risks-by-status-verified.riskStatusName'),
    },
    {
      key: 'applicationDate',
      dataIndex: 'applicationDate',
      title: t('last-risks-by-status-verified.creationDate'),

      render: (dataIndex) => (
        <span> {format(parseISO(dataIndex), 'dd.MM.yyyy.')}</span>
      ),
    },
    {
      key: 'value',
      title: t('last-potential-incurred.userCreated'),
      render: (request) => {
        return `${request.userCreatedFirstName} ${request.userCreatedLastName}`
      }
    },
  ];

  const linkTo = () => {
    let link;
    if (activeTab === 'last-potential-incurred') {
      link = '/risks';
    } else if (activeTab === 'last-court') {
      link = '/risks';
    } else if (activeTab === 'last-risks-by-status-unesen') {
      link = '/entered-risks';
    } else if (activeTab === 'last-risks-by-status-verified') {
      link = '/verified-risks';
    }
    return link;
  };

  return (
    <>
      <Row className="mx-5 py-5 dashboardTable">
        <Row className="dashboardTableHeader m-0">
          <Col xs="12" md="8" className="text-left pr-0 pl-0">
            <TabsNav
              items={[
                {
                  name: t('dashboard.tabsNav.last-potential-incurred'),
                  target: 'last-potential-incurred',
                },

                ...(departments.some((r) => r.id === 9) || userSuperAdmin || userRiskSector
                  ? [
                      {
                        name: t('dashboard.tabsNav.last-court'),
                        target: 'last-court',
                      },
                    ]
                  : []),

                {
                  name: t('dashboard.tabsNav.last-risks-by-status-unesen'),
                  target: 'last-risks-by-status-unesen',
                },
                {
                  name: t('dashboard.tabsNav.last-risks-by-status-verified'),
                  target: 'last-risks-by-status-verified',
                },
              ]}
              textProperty="name"
              itemValue="target"
              selectedItem={activeTab}
              onItemSelect={setActiveTab}
              classes="tabs-nav-dashboard"
            />
          </Col>
          <Col
            xs="12"
            md="4"
            className="text-right p-0"
            style={{marginTop: '10px'}}
          >
            <Link to={linkTo()}>
              {t('dahsboard.measures.seeAll')}
              <img src="../images/arrowGrey.svg" alt="arrow" />
            </Link>
          </Col>
        </Row>
        <Row className="ml-0 mr-0 mt-3">
          {activeTab === 'last-potential-incurred' && <First />}
          {activeTab === 'last-court' && <Second />}
          {activeTab === 'last-risks-by-status-unesen' && (
            <NoFormTable
              api="/risks/last-risks-by-status-added?size=5"
              columns={columns2}
              className={'table-hover'}
            />
          )}

          {activeTab === 'last-risks-by-status-verified' && (
            <NoFormTable
              api="/risks/last-risks-by-status-verified?size=5"
              columns={columns2}
              className={'table-hover'}
            />
          )}
        </Row>
      </Row>
    </>
  );
};

export default DashboardTable;
